angular.module('iw.frontyard.signup')
    .directive('iwCreateAccount', function ($window, Translator) {
        return {
            restrict: 'EA',
            link: function (scope, element, attributes) {
                updateAmountPlaceholder();

                scope.$watch('signup.FORMATTED_MIN_LOAN_SIZE', updateAmountPlaceholder);
                scope.$watch('signup.FORMATTED_MAX_LOAN_SIZE', updateAmountPlaceholder);

                function updateAmountPlaceholder() {
                    var text = 'Enter an amount from £%(FORMATTED_MIN_LOAN_SIZE)s - £%(FORMATTED_MAX_LOAN_SIZE)s';
                    scope.amountPlaceholder = Translator.translateAndInterpolate(text, scope.signup, true);
                }
            },
            template: function (tElement, tAttributes) {
                var requestedAmountInputElement = buildRequestedAmountInputElement();
                var existingEmailMessageElement = buildExistingEmailMessageElement();

                return `<div class="inner-content hide-footer">
    <div class="close-sign"
         ng-click="IwocaSiteHelper.closeOverlay()">
        <span></span><span></span>
    </div>


    <div class="main-content">

        <header class="overlay-header"
                ng-switch="signup.productType">

            <h1 class="" ng-switch-when="CREDIT_LINE" iw-translate>Get approved for a flexible Credit Line</h1>
            <h1 class="" ng-switch-when="TERM_LOAN" iw-translate>Get approved for a Small Business Loan</h1>
            <h1 class="" ng-switch-default iw-translate>Get approved for free</h1>

            <div class="description"
                 iw-translate>
                It takes less than 10 minutes to apply and there are no commitments
            </div>

        </header>

        <form class="form-accounts signup-form-accounts ng-pristine ng-valid"
              name="signup.form"
              novalidate
              ng-submit="signup.createAccount()">

            <div class="fields">

                <dl class="signup-email input-group-control error top-element"
                    ng-class="{ 'invalid': (signup.isInvalidOnCreateAccount || signup.isValidatedEmail) && signup.form.email.$invalid }">

                    <dt class="error">
                    <div class="error-message" iw-translate>Please enter a valid email address</div>
                    </dt>

                </dl>
                <dl class="signup-email input-group-control info"
                    ng-class="{ 'existing-email': signup.isEmailValidForServer === false }">

                    <dt class="info">
                        ${existingEmailMessageElement}
                    </dt>

                </dl>
                <dl class="signup-email input-group-control"
                    iw-on-defined-style-parent
                    ng-class="{ 'invalid': (signup.isInvalidOnCreateAccount || signup.isValidatedEmail) && signup.form.email.$invalid }">

                    <dt class="input-label">
                    <div class="label email-label" iw-translate>Email address</div>
                    </dt>

                    <dd>
                        <div class="input-control">
                            <input id="id_email"
                                   name="email"
                                   iw-on-defined-style="show-email-label"
                                   iw-disable-input
                                   disable-pattern="\\s"
                                   key-down="32"
                                   ng-model="signup.email"
                                   ng-model-options="{allowInvalid: true}"
                                   ng-change="signup.onEmailChange()"
                                   ng-blur="signup.checkEmailValidity()"
                                   placeholder="{{ 'name@company.com' | iwTranslate}}"
                                   required="required"
                                   ng-pattern="signup.emailValidityRegExp"
                                   type="email">
                        </div>
                    </dd>

                </dl>

                <dl class="signup-urgency input-group-control error top-element"
                    ng-class="{ 'invalid': signup.isInvalidOnCreateAccount && !signup.urgency }">

                    <dt class="error">
                    <div class="error-message" iw-translate>Please select one of the following options</div>
                    </dt>

                </dl>
                <dl class="signup-urgency input-group-control"
                    ng-class="{ 'invalid': signup.isInvalidOnCreateAccount && !signup.urgency }">

                    <dt class="input-label">
                    <div class="label" iw-translate>When are you looking to use iwoca?</div>
                    </dt>

                    <dd>
                        <div class="input-control">
                            <button id="id_high_urgency"
                                    ng-click="signup.setAsUrgent()"
                                    ng-class="{'active': signup.urgency === 3}"
                                    ng-keyup="signup.keyPressOnButtons($event)"
                                    type="button">
                                <i class="fa fa-clock-o" aria-hidden="true"></i>
                                <i class="radio-button"></i>
                                <label iw-translate>As soon as possible</label>
                            </button>

                            <button id="id_medium_urgency"
                                    class="lateral-border"
                                    ng-click="signup.setAsNotUrgent()"
                                    ng-class="{'active': signup.urgency === 2}"
                                    ng-keyup="signup.keyPressOnButtons($event)"
                                    type="button">
                                <i class="fa fa-calendar" aria-hidden="true"></i>
                                <i class="radio-button"></i>
                                <label iw-translate>
                                    Within a few weeks
                                </label>
                            </button>

                            <button id="id_approved_in_future"
                                    class="lateral-border"
                                    ng-click="signup.setAsApproveInFuture()"
                                    ng-class="{'active': signup.urgency === 1}"
                                    ng-keyup="signup.keyPressOnButtons($event)"
                                    type="button">
                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                                <i class="radio-button"></i>
                                <label iw-translate>I just want to see what's available</label>
                            </button>
                        </div>
                    </dd>
                </dl>

                <dl class="signup-requested-amount input-group-control error top-element"
                    ng-class="{ 'invalid': (signup.isInvalidOnCreateAccount || signup.isValidatedRequestedAmount) && signup.form.requested_amount.$invalid }">

                    <dt class="error">
                    <div class="error-message" iw-translate interpolate="signup">Please enter a requested amount up to £%(FORMATTED_MAX_LOAN_SIZE)s</div>
                    </dt>
                </dl>

                <dl class="signup-requested-amount input-group-control"
                    ng-class="{ 'last-element': !signup.showExtraFields,
                     'invalid': (signup.isInvalidOnCreateAccount || signup.isValidatedRequestedAmount) && signup.form.requested_amount.$invalid }">

                    <dt class="input-label">
                    <div class="label" iw-translate>How much would you like?</div>
                    </dt>

                    <dd>
                        <div class="input-control">
                            ${requestedAmountInputElement}
                        </div>
                    </dd>
                </dl>

                <dl class="signup-reason input-group-control error top-element extra-field"
                    ng-class="{ 'show-extra-field': signup.showExtraFields,
                     'invalid': signup.hasToValidateExtraFields && signup.form.reason.$invalid }">

                    <dt class="error">
                    <div class="error-message" iw-translate>Please select an option</div>
                    </dt>

                </dl>
                <dl class="signup-reason input-group-control extra-field"
                    ng-class="{'show-extra-field': signup.showExtraFields,
                     'invalid': signup.hasToValidateExtraFields && signup.form.reason.$invalid,
                      'last-element': !signup.showOtherReason }">
                    <dt class="input-label">
                    <div class="label" iw-translate>How will you use the funds?</div>
                    </dt>

                    <dd>
                        <div class="input-control">
                            <button type="button"
                                    ng-click="signup.toggleReasons()"
                                    class="wrapper-dropdown">
                                {{signup.selectedChoice ? signup.selectedChoice : 'Choose an option' | iwTranslate}}
                            </button>
                            <input ng-model="signup.reason"
                                   ng-change="signup.updateCreateAccountValidity()"
                                   ng-blur="signup.validateSingleInput('reason')"
                                   name="reason"
                                   hidden="true"
                                   required>
                        </div>
                    </dd>
                </dl>
                <dl ng-class="{ 'animate': signup.showReasons && signup.showExtraFields}"
                    class="dropdown-header">
                    <dt class="input-label">
                    <div class="label"></div>
                    </dt>
                    <dd>
                        <ul class="dropdown">
                            <li ng-repeat="choice in signup.choices"
                                ng-class="{'selected': signup.selectedChoice === choice.name}">
                                <button type="button"
                                        class="reason-choice"
                                        ng-disabled="!(signup.showReasons && signup.showExtraFields)"
                                        ng-click="signup.onReasonChange(choice)">
                                    {{choice.name | iwTranslate}}
                                </button>
                            </li>
                        </ul>
                    </dd>
                </dl>
                <dl class="signup-other-reason input-group-control error top-element extra-field last-element"
                    ng-class="{ 'show-extra-field': signup.showExtraFields && signup.showOtherReason,
                     'invalid': signup.hasToValidateExtraFields && signup.reason === 'other' && signup.form.detailed_purpose.$invalid }">

                    <dt class="error">
                    <div class="error-message" iw-translate>Please enter a valid reason</div>
                    </dt>

                </dl>
                <dl class="signup-other-reason input-group-control extra-field last-element"
                    iw-on-defined-style-parent
                    ng-class="{'show-extra-field': signup.showExtraFields && signup.showOtherReason,
                     'invalid': signup.hasToValidateExtraFields && signup.reason === 'other' && signup.form.detailed_purpose.$invalid }">

                    <dt class="input-label other-reason-label">
                    <div class="label" iw-translate>Please specify the purpose</div>
                    </dt>

                    <dd>
                        <div class="input-control">
                            <input id="id_detailed_purpose"
                                   name="detailed_purpose"
                                   iw-on-defined-style="show-other-reason-label"
                                   ng-model="signup.detailedReason"
                                   ng-model-options="{allowInvalid: true}"
                                   ng-change="signup.onOtherReasonChange()"
                                   ng-blur="signup.validateSingleInput('detailed_purpose')"
                                   placeholder="{{'Tell us how you will use the funds' | iwTranslate}}"
                                   required="required"
                                   type="text">
                        </div>
                    </dd>

                </dl>

            </div>


            <div class="signup-send-emails top-element">
                <label ng-class="{ 'selected': signup.marketingEmails }">
                    <input id="id_marketing_emails"
                           ng-model="signup.marketingEmails"
                           name="marketing_emails"
                           type="checkbox"
                           ng-init="signup.marketingEmails=true">
                    <i class="input-checkbox fa" aria-hidden="true"
                       ng-class="[signup.marketingEmails === true ? 'fa-check-square-o' : 'fa-square-o']"></i>
                    <div class="input-checkbox-label" iw-translate>Send me occasional emails to keep me up to date with iwoca (unsubscribe anytime)</div>
                </label>
            </div>


            <button class="create-account"
                    type="submit"
                    ng-class="{ 'invalid-form': signup.form.fname.$invalid
                    || signup.form.lname.$invalid
                    || signup.form.email.$invalid
                    || signup.isEmailValidForServer === false
                    || !(signup.urgency >= 1)
                    || signup.form.requested_amount.$invalid
                    || (signup.urgency >= 2 && (signup.form.requested_amount.$invalid || signup.form.reason.$invalid || (signup.reason === 'other' && signup.form.detailed_purpose.$invalid)) ) }"
                    ng-disabled="signup.isPending">
                <div class="label"
                     ng-if="signup.isPending !== true"
                     iw-translate>
                    Get started
                </div>
                <div class="label"
                     ng-if="signup.isPending === true"
                     iw-translate>
                    Creating your account...
                </div>
                <i class="fa"
                   ng-class="{'fa-arrow-circle-right': signup.isPending !== true,  'fa-circle-o-notch fa-spin': signup.isPending === true}"
                   aria-hidden="true"></i>
            </button>

        </form>

    </div>
</div>`;
            }
        };

        function buildRequestedAmountInputElement() {
            var currencySymbolisAlignedLeft = $window.LOCALE.indexOf('en') === 0;
            var currencyAlignmentClass = currencySymbolisAlignedLeft ? '' : 'currency-symbol-align-right';

            return `<input id="id_requested_amount"
                           iw-currency-input
                           min-currency-value="1"
                           max-currency-value="{{signup.MAX_LOAN_SIZE}}"
                           iw-disable-input
                           disable-pattern="[.][0-9]+$"
                           key-down="190"
                           ng-model="signup.requestedAmount"
                           ng-model-options="{allowInvalid: true}"
                           ng-change="signup.updateCreateAccountValidity()"
                           ng-blur="signup.validateRequestedAmount()"
                           name="requested_amount"
                           iw-remove-pattern-validator
                           pattern="[0-9]*"
                           autocomplete="off"
                           required
                           ng-attr-placeholder="{{amountPlaceholder}}">
                    <div class="currency-symbol ${currencyAlignmentClass}">
                        <div class="currency-symbol-value">${window.CURRENCY_FIELD_PLACEHOLDER}</div>
                    </div>`;

        }

        function buildExistingEmailMessageElement() {
            return `<div class="info-message">
                         <div class="inline" iw-translate context="existing_email_message" disable-trim="true">Oops. Someone has already signed up with that email address. Did you mean to </div>
                         <a ng-click="signup.redirectToLogin()" class="inline" iw-translate context="existing_email_message">log in</a>
                         <div class="inline" iw-translate context="existing_email_message" disable-trim="true"> to your account?</div>
                    </div>`;
        }

    });